import { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAddressInfo } from 'states/modules/addressField'
import { getStateField } from 'states/modules/stateField'

export const useCepAutocomplete = (
	form,
	fields,
	name,
	setState,
	onChange,
	personList = false,
	variableListName = '',
	prefix = ''
) => {
	const dispatch = useDispatch()
	const stateData = useSelector(({ stateField }) => stateField.data)

	const [cep, setCep] = useState('')

	const info = useSelector(({ addressInfo }) => addressInfo)
	const addressInfo = info.data[cep]
	const loading = info.loading[cep]

	const formattedSetCep = useCallback(
		(cep) => {
			setCep(cep.replace(/[^0-9]/g, ''))
		},
		[setCep]
	)

	useEffect(() => {
		if (cep.length === 8) {
			dispatch(getAddressInfo(cep))
		}
	}, [cep, dispatch])

	useEffect(() => {
		if (!stateData) dispatch(getStateField())
	}, [dispatch, stateData])

	useEffect(() => {
		const setValue = (field, value) => {
			onChange(value, field.toUpperCase())
			if (personList) {
				const fields = [...form.getFieldsValue()[variableListName]]

				const update = { ...fields[name], [field.toUpperCase()]: value }
				fields[name] = update

				return form.setFieldsValue({
					[variableListName]: fields,
				})
			}
			return form.setFieldsValue({
				[name]: { [field.toUpperCase()]: value },
			})
		}

		if (form && addressInfo) {
			fields.forEach((field) => {
				if (field === `${prefix}country`) {
					setValue(field, 'Brasil')
				}
				if (field === `${prefix}street`) {
					setValue(field, addressInfo.logradouro)
				}
				if (field === `${prefix}state`) {
					if (stateData) {
						const newValue = stateData.find(
							(item) => item.stateInitials === addressInfo.uf
						).state
						setValue(field, newValue)
						setState(newValue)
					}
				}
				if (field === `${prefix}city`) {
					setValue(field, addressInfo.localidade)
				}
				if (field === `${prefix}district`) {
					setValue(field, addressInfo.bairro)
				}
			})
		}
	}, [
		form,
		fields,
		addressInfo,
		name,
		stateData,
		setState,
		// TODO: analyze why this make the screen freeze on demands form
		// onChange,
		prefix,
		variableListName,
		personList,
	])

	return [formattedSetCep, loading]
}
